/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React, {Component} from 'react';
import {Link} from "react-router-dom";
import intl from 'react-intl-universal';

import AppNavbar from "../../InternetNavbar";
import AppFooter from "../../../components/AppFooter";
import { HELP_URL } from '../../../Constants';

class MainHelpArticle extends Component {

    render() {

        return (
            <div>
                <AppNavbar />

                <main id="content" role="main">
                    <div className="container space-bottom-2">
                        <div className="w-lg-80 mx-lg-auto">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb breadcrumb-no-gutter font-size-1 space-1">
                                    <li className="breadcrumb-item"><Link to="/">Internet</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">{intl.get('generic_help')}</li>
                                </ol>
                            </nav>

                            <div className="card shadow-sm p-7">
                                <h1 className="h2 font-weight-medium">{intl.get('generic_help')}</h1>

                                    <p>{intl.get('help_paragraph1')}</p>
                                    <p> </p>

                                <h1 className="h5">{intl.get('help_title2')}</h1>

                                    <p>{intl.get('help_paragraph21')}</p>
                                    <p>{intl.get('help_paragraph22')}</p>
                                    <p>{intl.getHTML('help_paragraph23')}</p>
                                    <p> </p>

                                <h1 className="h5">{intl.get('help_title3')}</h1>

                                    <p>{intl.get('help_paragraph31')}</p>
                                    <p>{intl.get('help_paragraph32')}</p>
                                    <p>{intl.get('help_paragraph33')}</p>
                                    <p>{intl.get('help_paragraph34')}</p>
                                    <p>{intl.get('help_paragraph35')}</p>
                                    <p> </p>

                                <h1 className="h5">{intl.get('help_title4')}</h1>

                                    <p>{intl.get('help_paragraph41')}</p>
                                    <p>{intl.get('help_paragraph42')}</p>
                                    <p> </p>

                                <h1 className="h5">{intl.get('help_title5')}</h1>

                                    <p>{intl.get('help_paragraph51')}</p>
                                    <p>{intl.getHTML('help_paragraph52')}</p>
                                    <p> </p>

                                <div className="mb-4">
                                    <h3 className="h5 font-weight-medium">{intl.get('generic_related_articles')}</h3>
                                </div>

                                <ul className="list-unstyled">
                                    <li className="pb-3"><Link className="link-underline" to="/help/what-s-an-outage">{intl.getHTML('generic_what_outage')}</Link></li>
                                    <li className="pb-3"><a className="link-underline" href={HELP_URL}>{intl.getHTML('generic_help_on_fing')}</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </main>
                <AppFooter/>
            </div>
        );
    }
}

export default MainHelpArticle;